export async function api<T = any>(
  path: string,
  body?: unknown,
  method?: string,
): Promise<T> {
  const r = await fetch("/api" + path, {
    credentials: "same-origin",
    method: method || (body === undefined ? "GET" : "POST"),
    headers: body === undefined ? {} : { "Content-Type": "application/json" },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const data = await r.json();
  if (!r.ok)
    throw Object.assign(new Error(data.error || "요청을 처리하지 못했어요."), {
      status: r.status,
    });
  return data;
}
export const money = (v: number) =>
  Math.round(v).toLocaleString("ko-KR") + "원";
export const shortMoney = (v: number) =>
  Math.abs(v) >= 10000
    ? `${(v / 10000).toLocaleString("ko-KR", { maximumFractionDigits: 1 })}만 원`
    : money(v);
export const signed = (v: number) => `${v > 0 ? "+" : ""}${money(v)}`;
export const pct = (v: number) => `${v > 0 ? "+" : ""}${v.toFixed(2)}%`;
export const cn = (v: number) =>
  v > 0 ? "positive" : v < 0 ? "negative" : "neutral";
export const labels: Record<string, string> = {
  sell: "전량 매도",
  half: "절반 매도",
  hold: "보유 유지",
  buy: "추가 매수",
};
// Plain words under each action so nobody has to guess what "hold" means.
export const hints: Record<string, string> = {
  sell: "모두 팔기",
  half: "절반만 팔기",
  hold: "사지도 팔지도 않기",
  buy: "더 사기",
};
export const modes: Record<string, string> = {
  daily: "오늘의 도전",
  practice: "자유 연습",
  tutorial: "첫 체험",
};
